import { render, staticRenderFns } from "./ApplicationSettings.vue?vue&type=template&id=db5fbd6a"
import script from "./ApplicationSettings.vue?vue&type=script&lang=ts"
export * from "./ApplicationSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports